export function isSome(value) {
    return value !== null && value !== undefined;
}
export function isNone(value) {
    return value === null || value === undefined;
}
export function IsNoneOrEmpty(value) {
    return isNone(value) || value === '';
}
//# sourceMappingURL=maybe.js.map